import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { PageLayout, Typography, TYPOGRAPHY_SIZE } from '@thinknet-gmbh/platform-common-ui';

import { ROUTES } from 'src/components/app/app-routes.constants';
import { VacanciesForm } from 'src/pages/vacancies/components/vacancies-form';

import { CreateVacancyPageWrapper } from './create-vacancy-page.styles';

const CreateVacancyPage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation(['jobs', 'common']);

  const navigateToVacanciesList = () => {
    navigate(ROUTES.vacancies);
  };

  return (
    <PageLayout pageTitle={t('jobs:labels.addNewVacancy')}>
      <CreateVacancyPageWrapper>
        <Typography weight="bold" size={TYPOGRAPHY_SIZE.medium}>
          {t('jobs:labels.addNewVacancy')}
        </Typography>
        <VacanciesForm onClose={navigateToVacanciesList} onSuccess={navigateToVacanciesList} />
      </CreateVacancyPageWrapper>
    </PageLayout>
  );
};

export default CreateVacancyPage;
